{
  "auth": {
    "listItem1": "Chez Oldcastle Infrastructure, la sécurité est une valeur fondamentale. Notre objectif est d'atteindre le ZÉRO ACCIDENT sur nos chantiers afin que chacun puisse rentrer chez soi sain et sauf. Nous nous protégeons et veillons les uns sur les autres, et dès que nous constatons un problème, nous intervenons immédiatement.",
    "listItem2": "Nous encourageons vivement chacun à intégrer la sécurité à son mode de vie, quel que soit l'environnement.",
    "subtitle": "Chez Oldcastle, la sécurité est notre priorité.",
    "title": "Formation en ligne des entrepreneurs"
  },
  "contractor": {
    "dashboard": {
      "title": "Formation en ligne des entrepreneurs {year}",
      "accessMessage": "Compléter la formation en ligne des entrepreneurs {year} pour avoir accès à nos sites à travers les États-Unis.",
      "bulletPoints": [
        "Vous pourrez choisir le ou les sites que vous souhaitez visiter à la fin du processus.",
        "Après avoir soumis la formation, vous recevrez un certificat que vous pourrez ensuite montrer à un responsable de site sur place pour entrer."
      ],
      "completedTitle": "Votre formation en ligne est complétée pour l'année {year}!",
      "assignedSites": "Vous avez accès à ce{plural} site{plural}.",
      "certificateSent": "Certificat envoyé!",
      "certificateResend": "Envoyer le certificat de nouveau",
      "explore": "Explorer les produits et services Oldcastle",
      "learn": "En savoir plus sur Oldcastle et ses valeurs",
      "addToSite": "M'ajouter à un site"
    },
    "label": "Entrepreneur",
    "list": "Liste des entrepreneurs",
    "search_placeholder": "Saisissez le nom d'un entrepreneur ou d'une entreprise..."
  },
  "orientation": {
    "title": "Formation en ligne des entrepreneurs",
    "preface": {
      "title": "Préface",
      "content": "<p>Gardez à l'esprit que cette formation sera <b>évaluée à la fin</b>. Vous devez lire attentivement la formation et en comprendre le contenu.</p><p>Si vous n'obtenez pas la note minimale acceptée par Oldcastle, vous devrez repasser le test jusqu'à ce que vous l'obteniez.</p>"
    },
    "testButton": "Tester vos connaissances",
    "quiz": {
      "title": "Test de compréhension final",
      "gradingTitle": "Processus de notation",
      "gradingContent": "<p class='mb-15'>Ce test de compréhension est noté. Si vous n'obtenez pas une note <strong>d'au moins {passing}%</strong> ou si vous ne répondez pas correctement à <strong>{goodAnswersRequired} questions sur {totalQuestions}</strong>, vous devrez repasser le test.</p><p>Si vous réussissez, vous pourrez sélectionner le site que vous souhaitez lier à votre certificat et, ensuite, visiter ce site OI spécifique.</p>",
      "start": "Commencer le test",
      "question": "Question",
      "true": "Vrai",
      "false": "Faux",
      "right": "Bonne réponse!",
      "wrong": "Mauvaise réponse!",
      "submit": "Soumettre votre réponse",
      "next": "Prochaine question",
      "finish": "Soumettre le test",
      "grade": "Résultat : {grade} %",
      "failed": "<p class=\"quiz-fail__text mb-15\">Malheureusement, vous n'avez pas réussi le test. Vous avez répondu incorrectement à <strong>{missed} questions</strong>. Pour obtenir votre certificat, vous devez avoir obtenir une note d'au moins {passing}%. Veuillez recommencer le test.<p class=\"quiz-fail__text\">De plus, ne cliquez pas sur \"Annuler\" avant d’avoir réussi le test et confirmé votre site associé. Si vous le faites, vous perdrez tout votre progrès.</p>",
      "retake": "Recommencer la formation"
    },
    "passed": {
      "congrats": "Félicitations! Vous avez complété la formation en ligne des entrepreneurs!",
      "email": "Votre certificat a été envoyé par courriel. Veuillez le présenter au responsable de site dès votre arrivée sur place.",
      "chooseSite": "La dernière étape consiste à choisir le site auquel vous souhaitez accéder. Vous pourrez le modifier jusqu'à ce que vous ayez terminé la formation secondaire donnée sur le site.",
      "successSite": "Vous avez sélectionné avec succès le site suivant.",
      "editSite": "Vous pourrez le modifier jusqu'à ce que vous ayez terminé la formation secondaire donnée sur le site.",
      "chooseSiteBtn": "Choisir ce site",
      "backHome": "Retourner à l'accueil"
    }
  },
  "reports": {
    "allCompaniesByYear": {
      "subtitle": "qui ont des entrepreneurs",
      "title": "Toutes les entreprises"
    },
    "allContractorsBySite": {
      "subtitle": "pour tous les sites ou par site spécifique",
      "title": "Tous les entrepreneurs"
    },
    "allContractorsInfo": {
      "subtitle": "avec leurs détails",
      "title": "Tous les entrepreneurs"
    },
    "allSites": {
      "subtitle": "avec les gestionnaires de site associés",
      "title": "Tous les sites"
    }
  },
  "quick_actions": {
    "company:add": {
      "text": "Ajoutez une entreprise pour que les entrepreneurs puissent la sélectionner lors de leur inscription.",
      "title": "Ajouter une entreprise"
    },
    "site:add": {
      "text": "Ajoutez un site pour y démarrer votre activité.",
      "title": "Ajouter un site"
    },
    "site-manager:add": {
      "text": "Associez un gestionnaire à un site vide, remplacez un gestionnaire existant ou créez-en un nouveau.",
      "title": "Ajouter un gestionnaire à un site"
    },
    "title": "Actions rapides"
  },
  "address": "Adresse",
  "add_company_info": "Ajouter des informations sur l'entreprise",
  "add_contractor": "Ajouter un entrepreneur",
  "add_cover_image": "Ajouter une image de couverture",
  "add_existing_manager": "Associer un gestionnaire existant",
  "add_manager": "Ajouter un gestionnaire de site",
  "add_new_manager": "Créer un nouveau gestionnaire",
  "add_site_info": "Ajouter des informations sur le site",
  "add_site_manager": "Ajouter un gestionnaire de site",
  "all_contractors_with_info_linked_to_selected_site": "Tous les entrepreneurs dont les informations sont liées au site sélectionné",
  "all_sites": "Tous les sites",
  "back_to_dashboard": "Retour au tableau de bord",
  "cancel": "Annuler",
  "choose_existing_manager": "Choisir un gestionnaire existant",
  "choose_site_to_link": "Choisissez un site à associer",
  "close_window": "Fermer la fenêtre",
  "companies": "Entreprises",
  "companies_profile": "Profil de l'entreprise",
  "company": "Entreprise",
  "company_been_added": "Cette entreprise a été ajoutée. Les informations la concernant peuvent être modifiés dans le profil de l'entreprise.",
  "company_name": "Nom de l'entreprise",
  "complete": "Complet",
  "confirm": "Confirmer",
  "confirmation_email_sent": "Un courriel de confirmation a été envoyé à l'utilisateur. Il sera possible de consulter son profil une fois l'adresse courriel vérifiée et le compte créé.",
  "contractor_name": "Nom de l'entrepreneur",
  "contractor_has_no_site": "Cet entrepreneur n'a pas encore de site attribué.",
  "contractor_has_not_completed_inductions_that_year": "Cet entrepreneur n'a suivi aucune formation cette année.",
  "contractor_has_not_completed_inductions_this_year": "Cet entrepreneur n'a suivi aucune formation cette année.",
  "contractor_has_not_done_inductions_yet": "Cet entrepreneur n'a pas encore complété de formation.",
  "contractors": "Entrepreneurs",
  "contractors_profile": "Profil de l'entrepreneur",
  "create_a_report": "Créer un rapport",
  "create_new_manager": "Créer un nouveau gestionnaire",
  "create_new_section": "Créer une nouvelle section",
  "current_status": "Statut actuel",
  "date_of_completion_online_orientation": "Date de complétion - Formation en ligne",
  "date_of_birth": "Date de naissance",
  "display_info_from_site": "Afficher les informations d'un site spécifique",
  "done": "Complété",
  "edit_cover_image": "Modifier l'image de couverture",
  "edit_the_orientation": "Modifier la formation",
  "email": "Adresse courriel",
  "errors": {
    "media_upload": "Échec du téléversement du média."
  },
  "final_comprehension_test": "Test de compréhension final",
  "first_name": "Prénom",
  "forgot_password": "Mot de passe oublié?",
  "incomplete": "Incomplet",
  "induction_complete_confirmation": "Êtes-vous sûr de vouloir changer le statut de la formation pour",
  "induction_completed_on": "Formation terminée le",
  "last_name": "Nom",
  "loading": "Chargement...",
  "logout_success": "Déconnexion réussie.",
  "manager": "Gestionnaire",
  "manager_detach_confirmation": "Êtes-vous sûr de vouloir supprimer ce gestionnaire de ce site? Cette action ne supprimera pas son profil.",
  "name": "Nom",
  "new_password": "Nouveau mot de passe",
  "next": "Suivant",
  "next_question": "Question suivante",
  "no_manager_history_for_year": "Ce site ne dispose pas d'historique de gestionnaires pour cette année.",
  "no_notifications": "Vous n'avez pas de notifications.",
  "notifications": "Notifications",
  "now_manager_of": "est maintenant un gestionnaire de",
  "orientation_published_successfully": "Formation publiée avec succès.",
  "on-site_training": "Formation sur site",
  "on-site_training_status": "Statut de la formation sur site",
  "password": "Mot de passe",
  "password_changed": "Le mot de passe a été réinitialisé avec succès.",
  "previous": "Précédent",
  "previous_question": "Question précédente",
  "profile": "Profil",
  "publish_orientation": "Publier la formation",
  "remember_me": "Se souvenir de moi",
  "resend": "Renvoyer",
  "reset": "Réinitialiser",
  "reset_password": "Réinitialiser le mot de passe",
  "reset_password_email_sent": " Un courriel a été envoyé avec succès à <strong>{email}</strong> afin de réinitialiser le mot de passe.",
  "results_in": "Résultats dans les",
  "review_choice": "Revoir le choix",
  "review_company_info": "Valider les informations sur l'entreprise",
  "review_site_info": "Valider les informations du site",
  "save": "Sauvegarder",
  "save_changes": "Enregistrer les modifications",
  "saving": "Enregistrement en cours...",
  "search": "Rechercher",
  "search_something": "Rechercher quelque chose...",
  "section": "section",
  "see_company_profile": "Voir le profil de l'entreprise",
  "see_manager_profile": "Voir le profil du gestionnaire",
  "see_more": "Voir plus",
  "see_previous_notifications": "Voir les notifications précédentes",
  "see_site_profile": "Voir le profil du site",
  "send": "Envoyer",
  "session_expired": "Votre session a expiré.",
  "sign_in": "Se connecter",
  "sign_in_success": "Connexion réussie.",
  "sign_up": "S'inscrire",
  "sign_up_email_sent": "Un courriel de confirmation a été envoyé à votre boîte de réception. Veuillez cliquer sur le lien dans le courriel pour valider votre adresse.",
  "sign_up_success": "Vous vous êtes inscrit avec succès !",
  "site": "Site",
  "sites": "Sites",
  "sites_profile": "Profil du site",
  "site_been_added": "Ce site a été ajouté. Il faudra éventuellement lui associer un gestionnaire.",
  "site_doesnt_have_managers": "Ce site n'a pas encore de gestionnaire.",
  "site_has_managers": "Ce site a déjà un ou plusieurs gestionnaires. Vous pouvez gérer leur rôle ci-dessous ou dans le profil du site.",
  "site_history": "Historique du site",
  "site_manager_history": "Historique du gestionnaire de site",
  "site_manager_name": "Nom du gestionnaire de site",
  "site-managers": "Gestionnaires de site",
  "site-managers_profile": "Profil du gestionnaire",
  "site_name": "Nom du site",
  "site_names": "Noms des sites",
  "site_status_history": "Historique du statut du site",
  "start": "Commencer",
  "switch_current_site": "Changer de site actuel",
  "to_do": "À faire",
  "to_selected_site": "Au site sélectionné",
  "year": "Année"
}
